// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import * as antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by DataParser.
export default class DataParserListener extends antlr4.ParseTreeListener {

	// Enter a parse tree produced by DataParser#line.
	enterLine(ctx) {
	}

	// Exit a parse tree produced by DataParser#line.
	exitLine(ctx) {
	}


	// Enter a parse tree produced by DataParser#Concat.
	enterConcat(ctx) {
	}

	// Exit a parse tree produced by DataParser#Concat.
	exitConcat(ctx) {
	}


	// Enter a parse tree produced by DataParser#Expr.
	enterExpr(ctx) {
	}

	// Exit a parse tree produced by DataParser#Expr.
	exitExpr(ctx) {
	}


	// Enter a parse tree produced by DataParser#Text.
	enterText(ctx) {
	}

	// Exit a parse tree produced by DataParser#Text.
	exitText(ctx) {
	}


	// Enter a parse tree produced by DataParser#ConcatParens.
	enterConcatParens(ctx) {
	}

	// Exit a parse tree produced by DataParser#ConcatParens.
	exitConcatParens(ctx) {
	}


	// Enter a parse tree produced by DataParser#Upper.
	enterUpper(ctx) {
	}

	// Exit a parse tree produced by DataParser#Upper.
	exitUpper(ctx) {
	}


	// Enter a parse tree produced by DataParser#Replace.
	enterReplace(ctx) {
	}

	// Exit a parse tree produced by DataParser#Replace.
	exitReplace(ctx) {
	}


	// Enter a parse tree produced by DataParser#Lower.
	enterLower(ctx) {
	}

	// Exit a parse tree produced by DataParser#Lower.
	exitLower(ctx) {
	}


	// Enter a parse tree produced by DataParser#AddDays.
	enterAddDays(ctx) {
	}

	// Exit a parse tree produced by DataParser#AddDays.
	exitAddDays(ctx) {
	}


	// Enter a parse tree produced by DataParser#MulDiv.
	enterMulDiv(ctx) {
	}

	// Exit a parse tree produced by DataParser#MulDiv.
	exitMulDiv(ctx) {
	}


	// Enter a parse tree produced by DataParser#AddSub.
	enterAddSub(ctx) {
	}

	// Exit a parse tree produced by DataParser#AddSub.
	exitAddSub(ctx) {
	}


	// Enter a parse tree produced by DataParser#Parens.
	enterParens(ctx) {
	}

	// Exit a parse tree produced by DataParser#Parens.
	exitParens(ctx) {
	}


	// Enter a parse tree produced by DataParser#Parse.
	enterParse(ctx) {
	}

	// Exit a parse tree produced by DataParser#Parse.
	exitParse(ctx) {
	}


	// Enter a parse tree produced by DataParser#Num.
	enterNum(ctx) {
	}

	// Exit a parse tree produced by DataParser#Num.
	exitNum(ctx) {
	}


	// Enter a parse tree produced by DataParser#Neg.
	enterNeg(ctx) {
	}

	// Exit a parse tree produced by DataParser#Neg.
	exitNeg(ctx) {
	}


	// Enter a parse tree produced by DataParser#Field.
	enterField(ctx) {
	}

	// Exit a parse tree produced by DataParser#Field.
	exitField(ctx) {
	}


	// Enter a parse tree produced by DataParser#Get.
	enterGet(ctx) {
	}

	// Exit a parse tree produced by DataParser#Get.
	exitGet(ctx) {
	}


	// Enter a parse tree produced by DataParser#GetEndDate.
	enterGetEndDate(ctx) {
	}

	// Exit a parse tree produced by DataParser#GetEndDate.
	exitGetEndDate(ctx) {
	}


	// Enter a parse tree produced by DataParser#GetDateRange.
	enterGetDateRange(ctx) {
	}

	// Exit a parse tree produced by DataParser#GetDateRange.
	exitGetDateRange(ctx) {
	}


	// Enter a parse tree produced by DataParser#GetStartDate.
	enterGetStartDate(ctx) {
	}

	// Exit a parse tree produced by DataParser#GetStartDate.
	exitGetStartDate(ctx) {
	}


	// Enter a parse tree produced by DataParser#getStartDateFunc.
	enterGetStartDateFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#getStartDateFunc.
	exitGetStartDateFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#getEndDateFunc.
	enterGetEndDateFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#getEndDateFunc.
	exitGetEndDateFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#getDateRangeFunc.
	enterGetDateRangeFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#getDateRangeFunc.
	exitGetDateRangeFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#addDaysFunc.
	enterAddDaysFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#addDaysFunc.
	exitAddDaysFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#replaceFunc.
	enterReplaceFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#replaceFunc.
	exitReplaceFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#getAspectFunc.
	enterGetAspectFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#getAspectFunc.
	exitGetAspectFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#parseFunc.
	enterParseFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#parseFunc.
	exitParseFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#lowerFunc.
	enterLowerFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#lowerFunc.
	exitLowerFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#upperFunc.
	enterUpperFunc(ctx) {
	}

	// Exit a parse tree produced by DataParser#upperFunc.
	exitUpperFunc(ctx) {
	}


	// Enter a parse tree produced by DataParser#stringTerm.
	enterStringTerm(ctx) {
	}

	// Exit a parse tree produced by DataParser#stringTerm.
	exitStringTerm(ctx) {
	}


	// Enter a parse tree produced by DataParser#intTerm.
	enterIntTerm(ctx) {
	}

	// Exit a parse tree produced by DataParser#intTerm.
	exitIntTerm(ctx) {
	}


	// Enter a parse tree produced by DataParser#args.
	enterArgs(ctx) {
	}

	// Exit a parse tree produced by DataParser#args.
	exitArgs(ctx) {
	}


	// Enter a parse tree produced by DataParser#name.
	enterName(ctx) {
	}

	// Exit a parse tree produced by DataParser#name.
	exitName(ctx) {
	}


	// Enter a parse tree produced by DataParser#term.
	enterTerm(ctx) {
	}

	// Exit a parse tree produced by DataParser#term.
	exitTerm(ctx) {
	}


	// Enter a parse tree produced by DataParser#literal.
	enterLiteral(ctx) {
	}

	// Exit a parse tree produced by DataParser#literal.
	exitLiteral(ctx) {
	}


	// Enter a parse tree produced by DataParser#int.
	enterInt(ctx) {
	}

	// Exit a parse tree produced by DataParser#int.
	exitInt(ctx) {
	}



}